<vw-toast-popup [isOpen]="isOpen"
  [title]="isSinglePlant ? ('garden.plant.end.title' | translate) : ('garden.plant.end.title-many' | translate: { count: plantCount })"
  [subtitle]="isSinglePlant ? (plants[0]?.cultivationVariant?.name | Label) : ''"
  (close)="onClose()">
  <div class="flex flex-col gap-4 px-4 pb-6">
    <p class="text-body-s text-vw-muted">
      {{ (isSinglePlant ? 'garden.plant.end.subtitle' : 'garden.plant.end.subtitle-many') | translate }}
    </p>

    <div class="flex flex-col gap-2">
      <p class="text-body-s font-semibold text-vw-body">{{ 'garden.plant.end.reason-label' | translate }}</p>
      <vw-choice-selector [ariaLabel]="('garden.plant.end.reason-label') | translate" variant="list" [options]="reasonOptions" [value]="reason" (valueChange)="onReasonChange($event)"></vw-choice-selector>
      @if (reasonMissing) {
        <!-- Bouton jamais grisé : un toucher sans motif dit ce qui manque, ici, sous la question. -->
        <p role="alert" class="text-body-s text-vw-danger" data-testid="end-culture-reason-missing">{{ 'garden.plant.end.reason-missing' | translate }}</p>
      }
    </div>

    <div class="flex flex-col gap-1">
      <p class="text-body-s font-semibold text-vw-body">{{ 'garden.plant.end.date-label' | translate }}</p>
      <vw-date-picker [initialValue]="date" [showInput]="true" [showDatepicker]="false" (dateSelected)="onDateChange($event)" class="w-full"></vw-date-picker>
    </div>

    @if (submitFailed) {
      <p role="alert" class="text-body-s text-vw-danger" data-testid="end-culture-error">{{ 'errors.businessException' | translate }}</p>
    }
    <!-- Bouton principal en bas, pleine largeur, comme les feuilles récentes. -->
    <vw-button
      (click)="submit()"
      [label]="isSinglePlant ? 'garden.plant.end.confirm' : ('garden.plant.end.confirm-many' | translate: { count: plantCount })"
      look="primary"
      customClass="w-full"
      [loading]="submitLoading"
    >
    </vw-button>
  </div>
</vw-toast-popup>
